<script>
import { required, numeric } from "vuelidate/lib/validators";
import validationMessages from "@/components/validations";
import Merchandising from "@/services/Merchandising";
import Swal from "sweetalert2";
import vueDropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Multiselect from 'vue-multiselect';
import _ from 'underscore';



export default {
  props: ['appProduct'],
  components: { vueDropzone, validationMessages, Multiselect },

  data() {
    return {
      brand_name: "",
      hasFiles: false,
      showModal: false,
      submitted: false,
      tryingToSubmit: false,
      showLoader: false,
      productLoader:true,
      csrf_token: localStorage.getItem("csrf_token"),
      productId:'',
      image_url: null,
      highlighted_image_url: null,
      title: "",
      description: "",
      price: "",
      discounted_price: "",
      is_highlighted: 0,
      loadingImage:false,
      is_published: 0,
      product_link:'',
      hasProductImage:false,
      hasHighlihtedImage:false,
      shopProducts:[],
      maxCharsTitle:60,
      charsTitleStart:0,
      charsDescriptionStart:0,
      maxCharsDescription:60,
      selectedProduct:[],
      previewImageObjectUrl: '',
      dropzoneOptions_image: {
        url: "/",
        autoProcessQueue: false,
        addRemoveLinks: false,
        dictRemoveFile: "",
        thumbnailWidth: 500, 
        thumbnailHeight: 700,
        thumbnailMethod: "contain",
        maxFilesize: 2,
        acceptedFiles: "image/*",
        maxFiles: 1,
        previewTemplate: `
          <div class="dz-preview dz-file-preview">
            <div class="dz-image">
              <img data-dz-thumbnail />
              <div class="button-overlay">
                <button id="custom-add-btn" type="button" class="custom-hover-change custom-border-radius shadow border-1 cursor-pointer btn  bg-white text-black btn-sm d-flex align-items-center justify-content-center gap-1" data-dz-remove>
                <i class="uil uil-edit text-black"></i>
                  <span class="cursor-pointer fw-medium">Change</span>
                </button>
                <button  type="button" class="custom-hover-delete custom-border-radius shadow cursor-pointer btn  bg-white text-danger btn-sm d-flex align-items-center justify-content-center gap-1" data-dz-remove>
                  <i class="uil uil-trash-alt text-danger"></i>
                  <span class="cursor-pointer fw-medium">Delete</span>
                </button>
              </div>
            </div>
          </div>
  `
      },
    };
  },

  validations: {
    title: { required },
    price: { required },
    product_link: { required },
    image_url: { required }
  },

  watch:{
      'selectedProduct':function(newVal){
        this.image_url = '';
        this.loadingImage = true;
        this.title = newVal && newVal.title ? newVal.title : '';
        this.description = newVal && newVal.description ? newVal.description : '';
        this.product_link = newVal && newVal.landingpage_url ? newVal.landingpage_url : '';
        this.price = newVal && newVal.price ? newVal.price : '';
        this.discounted_price = newVal && newVal.discount_price ? newVal.discount_price : '';
        this.image_url = newVal && newVal.image ? newVal.image : '';

          if (!this.image_url) {
            this.loadingImage = false;
          }

      setTimeout(() => {
        this.loadingImage = false;
      }, 5000);
      },
      'image_url': function(newVal){
         if (newVal !== null && newVal !== '' && (typeof newVal === 'string')) {
          this.hasProductImage = true;
        }
      },
  },
  computed:{
    remainingCharsTitle() {
      const currentLenght = this.title.length;
      if(currentLenght >= this.maxCharsTitle){
        return this.maxCharsTitle;
      }

      return this.charsTitleStart + currentLenght;
    },
    remainingCharsDescription() {
      const currentLenght = this.description.length;
      if (currentLenght >= this.maxCharsDescription) {
        return this.maxCharsDescription;
      }

      return this.charsDescriptionStart + currentLenght;
    },
    previewImageSrc() {
      if (this.previewImageObjectUrl) {
        return this.previewImageObjectUrl;
      }
      if (this.image_url && typeof this.image_url === 'string') {
        return this.image_url;
      }
      return require('@/assets/images/image_not_found.png');
    },
    formattedPrice() {
      return this.price ? `€ ${this.price}` : '€ 0.00';
    },
    formattedDiscountPrice() {
      return this.discounted_price ? `€ ${this.discounted_price}` : '';
    },
    showDiscountComparison() {
      if (this.price === '' || this.discounted_price === '') {
        return false;
      }

      const normalize = (value) => Number(String(value).replace(',', '.').trim());
      return !Number.isNaN(normalize(this.price)) &&
        !Number.isNaN(normalize(this.discounted_price)) &&
        normalize(this.price) !== normalize(this.discounted_price);
    },
  },
   
  methods: {
    updatePreviewImageObjectUrl(file) {
      if (this.previewImageObjectUrl) {
        URL.revokeObjectURL(this.previewImageObjectUrl);
        this.previewImageObjectUrl = '';
      }
      if (file instanceof File) {
        this.previewImageObjectUrl = URL.createObjectURL(file);
      }
    },
    addMoreFiles() {
      this.$refs.myVueDropzone_image.dropzone.hiddenFileInput.click();
    },
    fileAdded(file) {
      this.hasFiles = true
    },
    fileRemoved(file) {
      // Check if any files remain
      const remainingFiles = this.$refs.myDropzone.dropzone.files.length
      this.hasFiles = remainingFiles > 0
    },
    removeAllFiles() {
      this.$refs.myDropzone.removeAllFiles()
      this.hasFiles = false
    },
    async getShopProducts(){
      try{
        this.productLoader = true
        const response = await Merchandising.getProducts();
        this.shopProducts = response.data.data;
        this.productLoader = false

      }catch(error){
         this.error = error.response.data.error ? error.response.data.error : 'Error getting Shop Products';
         this.productLoader = false;
      }finally{
        this.productLoader = false;
      }
    },


    async submitForm() {
      this.tryingToSubmit = true;

      if (this.$v.$invalid) {
        this.submitted = true;
        this.tryingToSubmit = false;
        return;
      }

      this.showLoader = true;
      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("description", this.description);
      formData.append("landingpage_url", this.product_link);
      formData.append("price", this.price);
      if(this.discounted_price !== ''){
        formData.append("discount_price", this.discounted_price);
      }else{
        formData.append("discount_price", this.price);
      }
      // formData.append("is_highlighted",this.is_highlighted);
      formData.append("is_published",this.is_published);

      // if (this.highlighted_image_url !== '' && this.highlighted_image_url !== null) {
      //   formData.append("image_highlighted_url", this.highlighted_image_url);
      // } else {
      //   formData.append("image_highlighted_url", ""); 
      // }

      if(this.image_url !== '' && this.image_url !== null){
        formData.append("image_url", this.image_url);
      }else{
        formData.append("image_url","")
      }      
      try {
        const response = await Merchandising.addAppProduct(formData); 
        if (response.success === false) {
          Swal.fire("Error", response.error || "Failed to add product. Please try again.", "error");
        } else {
          Swal.fire("Success", "Product added successfully!", "success");
          this.closeModal();
          this.refreshData();
        }

      } catch (error) {
        console.error("Failed to add product:", error);
        const apiError = error.response?.data?.error;
        const errorMsg = (Array.isArray(apiError) ? apiError[0] : apiError)
          || error.response?.data?.message
          || error.message
          || "Failed to add products. Please try again.";
        Swal.fire("Error", errorMsg, "error");
        this.closeModal();
      } finally {
        this.tryingToSubmit = false;
        this.showLoader = false;
      }
    },


    resetForm() {
      this.title = "";
      this.description = "";
      this.image_url = null;
      this.highlighted_image_url = null;
      this.price = "";
      this.discounted_price = "";
      this.is_highlighted = 0;
      this.is_published = 0;
      this.submitted = false;
      this.tryingToSubmit = false;
      this.hasProductImage = false;
      this.hasHighlihtedImage = false;
      this.selectedProduct = [];
      this.shopProducts= [];
      this.loadingImage = false;
      this.updatePreviewImageObjectUrl(null);
      this.$v.$reset();


      if (this.$refs.dropzoneOptions_image) {
        this.$refs.dropzoneOptions_image.removeAllFiles();
      }
      // if (this.$refs.myVueDropzone_highlight) {
      //   this.$refs.myVueDropzone_highlight.removeAllFiles();
      // }
    },

    closeModal() {
      this.resetForm();
      this.showModal = false;
    },

    removeProductImage(){
      this.image_url = null;
      this.hasProductImage = false;
      this.updatePreviewImageObjectUrl(null);
    },
    // removeHighlightedImage() {
    //   this.highlighted_image_url = null;
    //   this.hasHighlihtedImage = false;
    // },

    selectImageUrl(files) {
      setTimeout(() => {
        let queuedFiles2 = this.$refs.myVueDropzone_image.getQueuedFiles();
        if (files.length > 1) {
          this.failedmsg('You can only have one large image')

          files.forEach((value) => {
            this.$refs.myVueDropzone_image.removeFile(value)
          });
        }

        this.image_url = files[0];
        this.updatePreviewImageObjectUrl(this.image_url);
      }, 250);
    },

   async openModal() {
    await this.getShopProducts();
    },



    refreshData() {
      this.$emit("onRefresh");
    },
  },

};
</script>

<template>
  <b-modal @shown="openModal" @hidden="resetForm" id="add_app_products" size="xl" v-model="showModal"
    title="Add product to in-app shop" title-class="font-18 fw-medium">
    <form @submit.prevent="submitForm">
      <div class="row">
        <div v-if="$v.$error" class="text-danger">Complete all fields</div>
        <div v-if="showLoader" class="card-body d-flex align-items-center justify-content-center">
          <b-spinner large></b-spinner>
        </div>
        <div v-else>
          <b-card-text>
            <div class="row">
           


              <div class="col-12 col-md-6">
                   <div v-if="productLoader" class="d-flex align-items-center justify-content-center">
                <b-spinner v-show="productLoader" large class="text-primary"></b-spinner>
              </div>
              <div v-else>
                  <b-form-group v-if="shopProducts.length">
                <label class="typo__label">Select a Web Shop Product</label>
                <multiselect class="custom-input-bg" v-model="selectedProduct"
                                label="title"
                                track-by="id"
                                placeholder="Start typing to search all the products"
                                :options="shopProducts"
                                :multiple="false"
                                :searchable="true"
                                :internal-search="true"
                                :clear-on-select="false"
                                :close-on-select="true"
                                :options-limit="10"
                                :max-height="600"
                                :show-no-results="false"
                                :hide-selected="true"
                               >
                <template slot="singleLabel" slot-scope="{ option, remove }">
                <span class="custom__tag">
                    <span>{{ option.title }} | {{ option.id }}</span>
                    <span class="custom__remove" @click="remove(option)">✖</span>
                </span>
                </template>
                </multiselect>
                </b-form-group>
              </div>

                <b-form-group>
                  <label class="mb-2 mt-3 fw-medium">Product Title</label>
                  <span class="custom-color-cyan-500 ms-2 fw-medium ">({{ remainingCharsTitle }}/{{ maxCharsTitle }} characters)</span>
                  <b-form-input :maxlength="maxCharsTitle" class="custom-input-bg border-0" v-model.trim="title" placeholder="Enter product title..."
                    :class="{ 'is-invalid': submitted && $v.title.$error }"></b-form-input>
                  <validationMessages v-if="submitted" :fieldName="'Product Title'" :validationName="$v.title">
                  </validationMessages>
                </b-form-group>

                <b-form-group>
                  <label class="mb-2 mt-3 fw-medium">Product Description</label>
                  <span class="custom-color-cyan-500 ms-2 fw-medium ">({{ remainingCharsDescription }}/{{ maxCharsDescription }} characters)</span>
                  <b-form-input placeholder="Enter product description..." :maxlength="maxCharsDescription" v-model.trim="description" class="custom-input-bg border-0"></b-form-input>
                </b-form-group>


                  <b-form-group>
                    <label class="mb-2 mt-3 fw-medium">Landing Page URL</label>
                  <b-form-input placeholder="https://example.com/product" v-model.trim="product_link" :class="{ 'is-invalid': submitted && $v.product_link.$error }" class="custom-input-bg border-0"></b-form-input>
                    <validationMessages v-if="submitted" :fieldName="'Landing Page URL'" :validationName="$v.product_link">
                  </validationMessages>
                </b-form-group>


                <b-form-group>
                 <label class="mb-2 mt-3 fw-medium">Product Price</label>
                <b-input-group label="Product Price">
                  <b-input-group-prepend is-text>
                    <span style="border:0px !important;" class="border-0 absolute left-3 top-1/2 -translate-y-1/2 text-gray-900">€</span>
                  </b-input-group-prepend>
                  <b-form-input class="custom-input-bg border-0" placeholder="0.00" v-model.trim="price"
                    :class="{ 'is-invalid': submitted && $v.price.$error }"></b-form-input>

                </b-input-group>
                 <validationMessages v-if="submitted" :fieldName="'Product Price'" :validationName="$v.price">
                  </validationMessages>
                </b-form-group>


                <b-form-group>
                  <label class="mb-2 mt-3 fw-medium">Product Discounted Price</label>
                  <b-input-group label="Product Price">
                    <b-input-group-prepend is-text>
                      <span style="border:0px !important;"
                        class="border-0 absolute left-3 top-1/2 -translate-y-1/2 text-gray-900">€</span>
                    </b-input-group-prepend>
                    <b-form-input class="custom-input-bg border-0" placeholder="0.00" v-model.trim="discounted_price"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <div class="d-flex justify-content-between align-items-center mt-4 mb-3">
                  <div>
                    <p class="fw-medium mb-0">Make Visible in App</p>
                    <p class=" text-gray-500 mb-0 custom-color-gray-500">Enable to publish this product in your app</p>
                  </div>
                    <b-form-checkbox-group class="checbox-custom-position custom-checkbox">
                      <div class="form-check form-switch form-switch-lg mb-3">
                        <input v-model="is_published" type="checkbox" class="form-check-input" id="switch1"
                          true-value="1" false-value="0" />
                      </div>
                    </b-form-checkbox-group>
                  </div>

                <div v-if="loadingImage" class="card-body d-flex align-items-center justify-content-center">
                  <b-spinner large></b-spinner>
                </div>
                <b-form-group>
                  <label class="mb-3 fw-medium">Product Image</label>
                  <span class="custom-color-cyan-500 ms-2 fw-medium ">(Recommended: 800 x 600 px)</span>
                  <div v-if="hasProductImage" class="d-flex flex-column align-items-center justify-content-center gap-2 mb-2">
                    <img @load="loadingImage = false" :src="previewImageSrc" class="app-product-upload-image" :style="{ display: loadingImage ? 'none' : 'block' }" />
                    <i class="cursor-pointer uil uil-trash-alt font-size-18 text-danger" @click="removeProductImage()" :style="{ display: loadingImage ? 'none' : 'block' }"></i>
                  </div>

                  <vue-dropzone
                    v-else
                    ref="myVueDropzone_image"
                    id="product-image-dropzone"
                    class="d-flex align-items-center justify-content-center p-0"
                    :options="dropzoneOptions_image"
                    @vdropzone-files-added="selectImageUrl"
                    :useCustomSlot=true
                  >
                    <div class="dropzone-custom-content">
                      <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-upload w-12 h-12 custom-color-gray-400 mb-4">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="17 8 12 3 7 8"></polyline>
                        <line x1="12" x2="12" y1="3" y2="15"></line>
                      </svg>
                      <h3 class="dropzone-custom-title custom-color-gray-400 font-size-16">Drop files here to upload</h3>
                      <div class="subtitle custom-color-gray-400 font-size-16">or click to browse</div>
                    </div>
                  </vue-dropzone>
                  <validationMessages v-if="submitted" :fieldName="'Product Image'" :validationName="$v.image_url">
                  </validationMessages>
                </b-form-group>
              </div>
              <div class="col-12 col-md-6">
                <label class="mb-3 fw-medium d-block">Preview</label>
                <div class="app-preview-card app-preview-normal app-preview-normal--single">
                  <div class="app-preview-image-wrap app-preview-image-wrap--normal">
                    <img :src="previewImageSrc" class="app-preview-image" :alt="title || 'Product image preview'" />
                  </div>
                  <div class="app-preview-body app-preview-body--normal">
                    <p class="app-preview-title">{{ title || 'Product name' }}</p>
                    <p class="app-preview-price-row mb-0">
                      <span class="app-preview-price-current">{{ formattedDiscountPrice || formattedPrice }}</span>
                      <span v-if="showDiscountComparison" class="app-preview-price-old">{{ formattedPrice }}</span>
                    </p>
                  </div>
                </div>
              </div>

            </div>



          </b-card-text>
        </div>
      </div>
    </form>

    <template v-slot:modal-footer>
      <b-button class="text-dark" variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" class="btn-dark" @click="submitForm" :disabled="tryingToSubmit || showLoader">
        <b-spinner v-show="tryingToSubmit" small></b-spinner>Add Product
      </b-button>
    </template>
  </b-modal>
</template>
<style>
#product-image-dropzone .dz-preview .dz-image {
  width: 100% !important;
  height: 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

#product-image-dropzone .dz-preview .dz-image img {
  object-fit: contain;
  /* Ensures the image scales without cropping */
  max-width: 100%;
  max-height: 100%;
}





/* Remove ALL hover effects */
#product-image-dropzone .dz-preview:hover .dz-image img {
  filter: none !important;
  transform: none !important;
  opacity: 1 !important;
}

#product-image-dropzone .dz-preview .dz-image::before,
#product-image-dropzone .dz-preview .dz-image::after {
  display: none !important;
  content: none !important;
}

#product-image-dropzone .dz-preview:hover {
  opacity: 1 !important;
  background: none !important;
}

#product-image-dropzone .dz-preview:hover .dz-details {
  opacity: 1 !important;
  background: none !important;
}

#product-image-dropzone .dz-preview .dz-details {
  opacity: 1 !important;
  position: relative !important;
  background: none !important;
}

/* Remove the semi-transparent overlay on hover */
#product-image-dropzone .dz-preview .dz-image {
  position: relative !important;
}

#product-image-dropzone .dz-preview:hover .dz-image {
  background: none !important;
}

/* Disable all transitions */
#product-image-dropzone .dz-preview * {
  transition: none !important;
}

#product-image-dropzone .dz-preview .dz-progress,
#product-image-dropzone .dz-preview .dz-success-mark,
#product-image-dropzone .dz-preview .dz-error-mark {
  display: none !important;
}

/* Make preview full width */
#product-image-dropzone .dz-preview {
  width: 100% !important;
  margin: 0 !important;
}

#product-image-dropzone .dz-preview .dz-image {
  width: 100% !important;
  height: auto !important;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative !important;
}

#product-image-dropzone .dz-preview .dz-image img {
  object-fit: contain;
  max-width: 100%;
  height: auto;
  width: 100%;
}

/* Overlay buttons on top of image */
.button-overlay {
    position: absolute;
    top: 95%;
    left: 110%;
    transform: translate(-50%, -50%);
    display: flex;
    gap: 10px;
    z-index: 55;
    width: 100%;
}
.input-group-text{
  border:0px !important
}
.custom-checkbox .form-check-input:checked{
  background-color: black !important;
  border: 0px !important;
}
.custom-input-bg .multiselect__tags {
  background-color: var(--custom-input-background) !important;
  border: 1px solid transparent !important;
  border-radius: 5px;
  color:black !important;
  border-radius: 5px !important;
}

.app-product-upload-image {
  width: 100%;
  max-width: 260px;
  border-radius: 10px;
}

.app-preview-card {
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  overflow: hidden;
}

.app-preview-normal--single {
  width: 50%;
  max-width: 220px;
}

.app-preview-image-wrap {
  overflow: hidden;
  background: #f3f4f6;
}

.app-preview-image-wrap--normal {
  aspect-ratio: 1 / 1;
}

.app-preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.app-preview-body--normal {
  text-align: left;
  padding: 10px;
}

.app-preview-title {
  font-size: 13px;
  font-weight: 700;
  color: #111111;
  margin-bottom: 6px;
  line-height: 1.35;
}

.app-preview-price-row {
  margin: 0;
}

.app-preview-body--normal .app-preview-price-current {
  font-size: 15px;
}

.app-preview-price-current {
  font-weight: 700;
  color: #111111;
}

.app-preview-price-old {
  color: #9aa0a6;
  text-decoration: line-through;
  font-size: 14px;
  margin-left: 6px;
  font-weight: 400;
}
</style>
